import { render, staticRenderFns } from "./RvsTimeWaveFormGraph.vue?vue&type=template&id=dbb8d182&scoped=true"
import script from "./RvsTimeWaveFormGraph.vue?vue&type=script&lang=ts"
export * from "./RvsTimeWaveFormGraph.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb8d182",
  null
  
)

export default component.exports